/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Unit_AssistedInputs */

const en_us2_workout_logging_unit_assisted = /** @type {(inputs: Workout_Logging_Unit_AssistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg of assistance`)
};

const pt_br2_workout_logging_unit_assisted = /** @type {(inputs: Workout_Logging_Unit_AssistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg de assistência`)
};

const es_419_workout_logging_unit_assisted = /** @type {(inputs: Workout_Logging_Unit_AssistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg de asistencia`)
};

const pt_pt2_workout_logging_unit_assisted = /** @type {(inputs: Workout_Logging_Unit_AssistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg de assistência`)
};

const fr_fr2_workout_logging_unit_assisted = /** @type {(inputs: Workout_Logging_Unit_AssistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg d'assistance`)
};

const de_de2_workout_logging_unit_assisted = /** @type {(inputs: Workout_Logging_Unit_AssistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg Unterstützung`)
};

const it_it2_workout_logging_unit_assisted = /** @type {(inputs: Workout_Logging_Unit_AssistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg di assistenza`)
};

/**
* | output |
* | --- |
* | "kg of assistance" |
*
* @param {Workout_Logging_Unit_AssistedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_unit_assisted = /** @type {((inputs?: Workout_Logging_Unit_AssistedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Unit_AssistedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_unit_assisted(inputs)
	if (locale === "es-419") return es_419_workout_logging_unit_assisted(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_unit_assisted(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_unit_assisted(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_unit_assisted(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_unit_assisted(inputs)
	return en_us2_workout_logging_unit_assisted(inputs)
});
export { workout_logging_unit_assisted as "workout-logging.unit_assisted" }